const sidebarSteps = (t) => [
  {
    target: '[data-menu="onboarding"]',
    title: t("explainer.sidebar.step1.title", "Démarrer mon projet immo"),
    description: t("explainer.sidebar.step1.desc", "Suivez les actions recommandées pour vous familiariser avec la plateforme et bien démarrer votre projet immobilier."),
  },
  {
    target: '[data-menu="dashboard"]',
    title: t("explainer.sidebar.step2.title", "Tableau de bord"),
    description: t("explainer.sidebar.step2.desc", "Pilotez toutes les dimensions de votre projet immobilier depuis votre tableau de bord."),
  },
  {
    target: '[data-menu="transactionTool"]',
    title: t("explainer.sidebar.step3.title", "Mon parcours immo digital"),
    description: t("explainer.sidebar.step3.desc", "Que vous soyez propriétaire (vendeur, bailleur) ou candidat (achat, location), le Parcours immo digital vous guide à chaque étape pour réussir votre projet immobilier."),
  },
  {
    target: '[data-menu="myAgentImmo"]',
    title: t("explainer.sidebar.step4.title", "Votre assistant immo IA"),
    description: t("explainer.sidebar.step4.desc", "Votre assistant répond à vos questions, répond aux candidats potentiels, organise des visites, identifie et analyse les biens qui correspondent à votre recherche."),
  },
  {
    target: '[data-menu="searchProperties"]',
    title: t("explainer.sidebar.step7.title", "Rechercher un bien"),
    description: t("explainer.sidebar.step7.desc", "Trouvez des biens en vente, en location ou dans l'annuaire pour anticiper votre projet."),
  },
  {
    target: '[data-menu="searchListingsDiscover"]',
    title: t("explainer.sidebar.searchListings.title", "Annonce de recherche immobilière"),
    description: t("explainer.sidebar.searchListings.desc", "Postez votre recherche et les membres, propriétaires de biens correspondants à votre recherche sont alertés et reviennent vers vous."),
  },
  {
    target: '[data-menu="dreamBigger"]',
    title: t("explainer.sidebar.dreamBigger.title", "Rêvons plus grand"),
    description: t("explainer.sidebar.dreamBigger.desc", "Vous avez un projet d'achat dans plusieurs mois ou années, trouvez aujourd'hui les biens que vous pourriez acheter dans le futur et ajoutez les à votre Wish List immo pour les suivre dans le temps."),
  },
  {
    target: '[data-menu="followedProperties"]',
    title: t("explainer.sidebar.step8.title", "Wish liste immo"),
    description: t("explainer.sidebar.step8.desc", "Le bien de vos rêves n'est pas en vente ? Pas de soucis ! Ajoutez le à votre Wish liste et vous serez informé de tout changement de statut ou de l'ajout d'information clés sur le profil du bien."),
  },
  {
    target: '[data-menu="estimation"]',
    title: t("explainer.sidebar.step9.title", "Baromètre prix"),
    description: t("explainer.sidebar.step9.desc", "Combien paierez-vous pour un bien donné ? Votre avis compte plus que celui d'un algorithme. Aidez les membres de la communauté."),
  },
  {
    target: '[data-menu="transactionMgmt"]',
    title: t("explainer.sidebar.step10.title", "Les outils pour le propriétaire"),
    description: t("explainer.sidebar.step10.desc", "Un ensemble d'outils pour vous aider à mener à bien votre projet de vente ou de mise en location de votre bien."),
  },
  {
    target: '[data-menu="purchaseRentMgmt"]',
    title: t("explainer.sidebar.step11.title", "Les outils pour les candidats"),
    description: t("explainer.sidebar.step11.desc", "Augmentez vos chances de trouver le bien idéal grâce à vos outils."),
  },
  {
    target: '[data-menu="toolbox"]',
    title: t("explainer.sidebar.step12.title", "Vos repères immobiliers"),
    description: t("explainer.sidebar.step12.desc", "Entrez une adresse ou choisissez un bien et obtenez instantanément de nombreux indicateurs : estimation, transactions récentes, permis de construire dans le voisinage, le collège de secteur..."),
  },
  {
    target: '[data-menu="learningCenter"]',
    title: t("explainer.sidebar.step5.title", "Learning center"),
    description: t("explainer.sidebar.step5.desc", "Formez-vous pour mener votre transaction de manière autonome."),
  },
  {
    target: '[data-menu="marketplace"]',
    title: t("explainer.sidebar.step6.title", "Services à la carte"),
    description: t("explainer.sidebar.step6.desc", "Vendez seul mais accompagné ! Les agents partenaires vous proposent des services à la carte sans commission."),
  },
];

export default sidebarSteps;
